import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ClippingStudioGraphicCatalogItem } from "app/js/src/domain/clipping-studio/clipping-studio-graphic-catalog";

const LOGO_ASSET_MAP: Record<string, string> = {
  RFI: "/assets/FTV/RFI.png",
  france24: "/assets/FTV/france24.png",
};

const TYPES_WITH_DURATION = new Set([
  "logo",
  "fruit-icon",
  "emoji",
]);

@Component({
  selector: "evrideo-clipping-studio-graphic-card",
  templateUrl: "./clipping-studio-graphic-card.component.html",
  styleUrls: ["./clipping-studio-graphic-card.component.scss"],
})
export class ClippingStudioGraphicCardComponent {
  @Input() item!: ClippingStudioGraphicCatalogItem;
  @Input() isEditMode = true;
  @Output() add = new EventEmitter<ClippingStudioGraphicCatalogItem>();

  get initials(): string {
    return this.item.mainText
      .split(" ")
      .map((w) => w.charAt(0))
      .join("")
      .slice(0, 3);
  }

  get logoImageUrl(): string {
    if (this.item.thumbnailUrl) return this.item.thumbnailUrl;
    if (this.item.logoKey && LOGO_ASSET_MAP[this.item.logoKey])
      return LOGO_ASSET_MAP[this.item.logoKey];
    return "";
  }

  get isLogoWithImage(): boolean {
    return this.item.type === "logo" && !!this.logoImageUrl;
  }

  get durationLabel(): string | null {
    if (!TYPES_WITH_DURATION.has(this.item.type)) return null;
    return this.item.durationLabel || null;
  }

  onAdd(): void {
    this.add.emit(this.item);
  }
}
